import type { ReactNode } from 'react';
import { Box } from '@mui/material';

interface PillProps {
  children: ReactNode;
  color: string;
  bg: string;
  bordered?: boolean;
  sx?: object;
}

/** Small rounded status label used across the plan output tabs. */
export const Pill = ({ children, color, bg, bordered, sx }: PillProps) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      fontSize: 10,
      fontWeight: 600,
      px: 1,
      py: 0.375,
      borderRadius: 5,
      letterSpacing: '0.03em',
      color,
      bgcolor: bg,
      border: bordered ? `1px solid ${color}` : 'none',
      ...sx,
    }}
  >
    {children}
  </Box>
);
